import { skipToken } from '@reduxjs/toolkit/query';
import { useCreateDialogChip, useCreateRoute } from 'components/create-dialog/CreateDialogContext';
import Loader from 'components/Loader';
import useAuth from 'hooks/useAuth.ts';
import { useMemo } from 'react';
import { useGetTaskByIdQuery } from 'store/api/tasks';
import { useGetCurrentTenantQuery } from 'store/api/tenants';
import { TaskForm } from 'types/tasks';
import { useClassifiers } from 'utils/useClassifiers';
import { taskDtoToForm } from './taskFormMapping';
import TaskPageForm from './TaskPageForm';

const TaskPageDuplicate = (): JSX.Element => {
    const { id: originalTaskId } = useCreateRoute().params;
    const { data: originalTask, isError } = useGetTaskByIdQuery(originalTaskId ?? skipToken);
    useCreateDialogChip({ copyOf: originalTask?.name });
    const { user: currentUser } = useAuth();
    const { data: tenantData } = useGetCurrentTenantQuery();
    const emailOrganizer = tenantData?.emailOrganizer;

    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({
        codes: ['TASK_PRIORITY_TYPE', 'TASK_TYPE', 'CORRESPONDENCE_TYPE', 'CORRESPONDENCE_DIRECTION'],
    });

    const initialData = useMemo<TaskForm | undefined>(() => {
        if (!currentUser || !originalTask) return undefined;
        return taskDtoToForm(originalTask, { classifiers, currentUser, emailOrganizer });
    }, [classifiers, originalTask, currentUser, emailOrganizer]);

    if (isLoadingClassifiers || (initialData === undefined && !isError)) {
        return <Loader />;
    }

    return <TaskPageForm type="add" classifiers={classifiers} initialData={initialData} />;
};

export default TaskPageDuplicate;
